
import { MapTo } from '@adobe/aem-react-editable-components';
import DiagnosticInformationCollector, { DiagnosticInformationCollectorEditConfig } from './DiagnosticInformationCollector';

export default MapTo('cob-corp-acquisition/components/creditonebank/diagnostic-information-collector')(DiagnosticInformationCollector, DiagnosticInformationCollectorEditConfig);
